import { render, staticRenderFns } from "./VisitDetail.vue?vue&type=template&id=662a0ee6&scoped=true"
import script from "./VisitDetail.vue?vue&type=script&lang=js"
export * from "./VisitDetail.vue?vue&type=script&lang=js"
import style0 from "./VisitDetail.vue?vue&type=style&index=0&id=662a0ee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662a0ee6",
  null
  
)

export default component.exports